import { ThemeProvider } from 'next-themes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { PhotoboothPage } from './pages/deai-photobooth';
import { PotionCraftPage } from './pages/PotionCraft';
import { FortuneTellingPage } from './pages/FortuneTelling';
import { VirtualIdolPage } from './pages/VirtualIdol';

export const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/photobooth/:source?",
      element: <PhotoboothPage />,
    },
    {
      path: "/potioncraft",
      element: <PotionCraftPage />,
    },
    {
      path: "/fortunetelling",
      element: <FortuneTellingPage />,
    },
    {
      path: "/virtualidol",
      element: <VirtualIdolPage />,
    }
  ]);

  return (
    <ThemeProvider defaultTheme="system" storageKey="ui-theme">
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};